const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user likes component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Suggestions} Suggestions the resource defined to manage Suggestions
 */
app.directive('userLikes', ['Application', 'Authorization', 'Suggestions', function (Application, Authorization, Suggestions) {
    return {
      restrict: 'E',
      replace: true,
      template: require('../../templates/directives/user-likes.html'),
      controller: function () {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;
        self.suggestions = [];

        var parseSuggestions = function(items) {
          angular.forEach(items, function(suggestion) {
            var temp = {};
            if (suggestion.event) {
              temp._id = suggestion.event._id;
              temp.title = suggestion.event.title;
              temp.type = 'event'
              temp.iconClass = "newspaper";
            } else if (suggestion.article) {
              temp._id = suggestion.article._id;
              temp.title = suggestion.article.title;
              temp.type = 'article'
              temp.iconClass = "article";
            } else if (suggestion.media) {
              temp.title = suggestion.media.title;
              if (suggestion.media.type === 'video') {
                temp._id = suggestion.media._id;
                temp.type = 'video'
                temp.iconClass = "play";
              } else {
                temp._id = suggestion.media._id;
                temp.type = 'file'
                temp.iconClass = "file";
              }
            } else {
              return;
            }

            self.suggestions.push(temp);
          });
        };

        self.goTo = function(type, id) {
          Application.navigation.goTo('/view/' + type + 's/' + id);
        };

        self.initialize = function () {
          self.loading = true;
          Suggestions.find({
            'article-populate': 'title',
            'media-populate': 'title,type',
            'event-populate': 'title',
            user: Authorization.getAuthToken().user._id,
            fields: 'article,media,event,track'
          }, function (data) {
            parseSuggestions(data);
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting suggestions ', error);
            Application.notifications.setError('Unable to get suggestions.');
          });
        };
        self.initialize();
      },
      controllerAs: 'userlikes'
    };
  }]);
